import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { ENGLISH, POLISH, translate } from "i18n/translate";

export const LANGUAGE_STORAGE_KEY = "language";
export { ENGLISH, POLISH };

const LanguageContext = createContext();

const getInitialLanguage = () => {
    if (typeof window === "undefined") {
        return ENGLISH;
    }
    return window.localStorage.getItem(LANGUAGE_STORAGE_KEY) === POLISH
        ? POLISH
        : ENGLISH;
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguageState] = useState(getInitialLanguage);

    useEffect(() => {
        document.documentElement.lang = language;
        window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    }, [language]);

    const setLanguage = useCallback((nextLanguage) => {
        setLanguageState(nextLanguage === POLISH ? POLISH : ENGLISH);
    }, []);

    const t = useCallback((key, params) => translate(language, key, params), [language]);

    const value = useMemo(
        () => ({ language, setLanguage, t }),
        [language, setLanguage, t]
    );

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const FixedLanguage = ({ language, children }) => {
    const t = useCallback((key, params) => translate(language, key, params), [language]);
    const setLanguage = useCallback(() => {}, []);
    const value = useMemo(
        () => ({ language, setLanguage, t }),
        [language, setLanguage, t]
    );

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error("useLanguage must be used within a LanguageProvider");
    }
    return context;
};
